// extracted by mini-css-extract-plugin
module.exports = {"goGreen":"#72a102","red":"#cc0432","orange":"#ff8a00","grey":"#888","greyDark":"#5f5f5f","info":"#01a365","container":"GameContainer_container__3SBlg"};